module.exports = __webpack_public_path__ + "static/media/logo_rev.43a75871.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_rev.png
// module id = 308
// module chunks = 0